import React from "react";
import { BrowserRouter as Router, Route, Redirect, Switch, HashRouter } from "react-router-dom";
import { useSelector } from 'react-redux'

import {
  ContestBeginScreen,
  ContestScreen,
  ContestLandingScreen,
  ContestFlowScreen,
  ContesthistoryScreen,
  StartContestScreen,
  SuccessContestScreen,
  TermsconditionsScreen,
  PrivacypolicyScreen,
  CelebrityScreen,
  CelebrityregistScreen,
  Header,
  Footer,
  GiftCardScreen,
  BeforeGiftCardScreen,
  PaymentScreen,
  DidyouknowScreen,
  Profile,
  MyorderScreen,
  NotificationsScreen,
  FaqScreen,
  HomeScreen,
  Participationhistory,
  ParticipationDetails,
  Login,
  Otp,
  Referral,
  WorngContestScreen,
  Rewards,
  AboutUsScreen,
  ReferearnScreen,
  ContactUsScreen,
  LeaderboardScreen,
  Fourscreen,
  Fourscreen1,
  DidyouknowDitelsScreen
} from "../pages";



function CommonRouteWithoutHeaderFooter({ component: Component, authed, ...rest }) {
  return (
    <Route
      {...rest}
      render={(props) => <div>
        <Component {...props} />
      </div>}
    />
  )
}

function CommonRoute({ component: Component, authed, ...rest }) {
  return (
    <Route
      {...rest}
      render={(props) => <div>
        <Header />
        <div style={{ minHeight: '50vh' }}><Component {...props} /></div>
        <Footer />
      </div>}
    />
  )
}

function PrivateRouteWithoutHeaderFooter({ component: Component, authed, ...rest }) {
  return (
    <Route
      {...rest}
      render={(props) => authed ? <div>
        aaa
        <Component {...props} />
      </div>
        : <Redirect to={{ pathname: '/login', state: { nexturl: props.location.pathname } }} />}
    />
  )
}

function PrivateRoute({ component: Component, authed, ...rest }) {
  return (
    <Route
      {...rest}
      render={(props) => authed ? <div>
        <Header />
        <div style={{ minHeight: '50vh' }}><Component {...props} /></div>
        <Footer></Footer>
      </div>
        : <Redirect to={{ pathname: '/login', state: { nexturl: props.location.pathname } }} />}
    />
  )
}

function Routers() {
  const token = useSelector((state) => state.auth.token)
  return (
    <HashRouter>
      <Switch>
        <CommonRoute exact path='/' component={HomeScreen} />
        <CommonRouteWithoutHeaderFooter path="/login" component={Login} />
        <CommonRouteWithoutHeaderFooter path="/otp" component={Otp} />
        <CommonRouteWithoutHeaderFooter path="/referral" component={Referral} />
        <CommonRoute authed={token} path="/landing/:id" component={ContestLandingScreen} />
        <CommonRoute authed={token} path="/contest" component={ContestScreen} />
        <PrivateRoute authed={token} path="/giftcard" component={GiftCardScreen} />
        <PrivateRouteWithoutHeaderFooter authed={token} path="/beforecontestgiftcard" component={BeforeGiftCardScreen} />
        <PrivateRouteWithoutHeaderFooter authed={token} path="/payment" component={PaymentScreen} />
        <PrivateRouteWithoutHeaderFooter authed={token} path="/contesthistory/:id" component={ContesthistoryScreen} />
        <PrivateRouteWithoutHeaderFooter authed={token} path="/profile" component={Profile} />
        <PrivateRoute authed={token} path="/myorder" component={MyorderScreen} />
        <PrivateRoute authed={token} path="/participationhistory" component={Participationhistory} />
        <PrivateRoute authed={token} path="/participationDetails/:id" component={ParticipationDetails} />
        <PrivateRoute authed={token} path="/notifications" component={NotificationsScreen} />

        <CommonRoute authed={token} path="/faq" component={FaqScreen} />
        <PrivateRouteWithoutHeaderFooter authed={token} path="/contestflow" component={ContestFlowScreen} />
        <PrivateRouteWithoutHeaderFooter authed={token} path="/StartContest" component={StartContestScreen} />
        <PrivateRouteWithoutHeaderFooter authed={token} path="/SuccessContest" component={SuccessContestScreen} />
        <PrivateRouteWithoutHeaderFooter authed={token} path="/WorngContest" component={WorngContestScreen} />
        <CommonRoute path="/leaderboard/:id" component={LeaderboardScreen} />
        <CommonRoute path="/rewards" component={Rewards} />
        <CommonRoute path="/aboutus" component={AboutUsScreen} />
        <CommonRoute path="/termsconditions" component={TermsconditionsScreen} />
        <CommonRoute path="/privacypolicy" component={PrivacypolicyScreen} />
        <PrivateRoute authed={token} path="/referearn" component={ReferearnScreen} />
        <CommonRouteWithoutHeaderFooter path="/contactus" component={ContactUsScreen} />
        <CommonRoute path="/celebrity" component={CelebrityregistScreen} />
        <CommonRouteWithoutHeaderFooter path="/celebrity2" component={CelebrityScreen} />
        <CommonRoute path="fourscreen" component={Fourscreen1} />
        <CommonRoute path="/contestbegins" component={ContestBeginScreen} />
        <CommonRoute path="/didyouknow" component={DidyouknowScreen} />
        <CommonRouteWithoutHeaderFooter path="/didyouknowditels" component={DidyouknowDitelsScreen} />
        <CommonRoute path="*" component={Fourscreen} />
      </Switch>
    </HashRouter>
  );
}

export default Routers